export default __webpack_public_path__ + "static/media/Newsletter 007.5c2f6d74.png";